import styled, { css } from 'styled-components';

export const Container = styled.div<{ $size: number }>`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Header = styled.div<{ $size: number }>`
  display: flex;
  flex-direction: row;
  flex: 1;

  align-items: center;
  justify-content: space-between;

  padding-top: ${({ theme, $size }) => theme.spacing[$size]}px;
  padding-bottom: ${({ theme, $size }) => theme.spacing[$size]}px;

  cursor: pointer;
`;

export const Titulo = styled.h1`
  ${({ theme }) => {
    return css`
      font-size: ${theme.typography.font.size[3]}px;
      font-family: var(--font-${theme.typography.font.family.text});
      font-weight: ${theme.typography.font.weight.bold};
      line-height: ${theme.typography.font.line_height[3]}px;
      text-align: left;
      color: ${theme.tokens.colors.text};
    `;
  }}
`;

export const IconContainer = styled.div<{ $estaAberto: boolean }>`
  transition: transform 0.3s ease;
  transform: ${({ $estaAberto }) => ($estaAberto ? 'rotate(180deg)' : '')};
`;

export const Conteudo = styled.div<{ $estaAberto: boolean }>`
  display: flex;
  max-height: ${({ $estaAberto }) => ($estaAberto ? '100%' : '0')};
  overflow: hidden;

  padding-top: ${({ theme, $estaAberto }) =>
    $estaAberto ? `${theme.spacing[4]}px` : '0'};

  padding-bottom: ${({ theme, $estaAberto }) =>
    $estaAberto ? `${theme.spacing[4]}px` : '0'};

  ${({ theme }) => {
    return css`
      a {
        font-size: ${theme.typography.font.size[3]}px;
        font-family: var(--font-${theme.typography.font.family.text});
        font-weight: ${theme.typography.font.weight.bold};
        line-height: ${theme.typography.font.line_height[3]}px;
        color: ${theme.colors.neutral.neutral[12]};
        text-decoration: underline;
      }
    `;
  }}

  ${({ theme }) => {
    return css`
      font-size: ${theme.typography.font.size['3']}px;
      font-family: var(--font-${theme.typography.font.family.text});
      font-weight: ${theme.typography.font.weight.regular};
      line-height: ${theme.typography.font.line_height['3']}px;
      text-align: left;
      color: ${theme.colors.neutral.neutral['11']};
    `;
  }}
`;
